import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";
export const metadata: FigureMetadata = {
  id: "EGRA",
  title: defineMessage({
    id: "fig.learning.EGRA.title",
    defaultMessage: `Ability to read at least one word of connected text in early grades`,
  }),
  caption: defineMessage({
    id: "fig.learning.EGRA.caption",
    defaultMessage: `In some countries, many children cannot read even a single word after several years of schooling.`,
  }),
  source: defineMessage({
    id: "fig.learning.EGRA.source",
    defaultMessage: `USAID Early Grade Reading Barometer`,
  }),
};
